import currencyFormats from 'constants/currency-constants';

const parseFare = fareStr => {
  if (!fareStr) {
    return undefined;
  }

  const { currencyString, fareFrom } = extractCurrencyString(fareStr);
  if (!currencyString) {
    return undefined;
  }

  const { currency, amount } = parseCurrencyString(currencyString);
  if (!currency || amount === undefined) {
    return undefined;
  }

  return {
    valid: true,
    currency,
    amount,
    fareFrom,
  };
};

const currencyStringRegex = new RegExp(/(S\$|Rp|RM|K|₱|฿)?[\d.,]+(៛|₫)?/);
const extractCurrencyString = str => {
  if (!str) {
    return {};
  }
  const match = currencyStringRegex.exec(str);
  if (!match) {
    return {};
  }
  return {
    currencyString: match[0],
    fareFrom: match[0] !== str,
  };
};

export const parseCurrencyString = currencyString => {
  if (!currencyString || typeof currencyString !== 'string') {
    return {};
  }

  let matchedCurrency;
  currencyFormats.forEach(currency => {
    if (!matchedCurrency && currencyString.includes(currency.symbol)) {
      matchedCurrency = currency;
    }
  });

  if (!matchedCurrency) {
    return {};
  }

  const {
    symbol = '',
    thousandFormat = ',',
    decimalFormat = '.',
  } = matchedCurrency;
  const currencyStringWithoutSymbol = currencyString.replace(symbol, '');
  const currencyStringWithoutThousandFormat = currencyStringWithoutSymbol.replace(
    thousandFormat,
    '',
  );
  const currencyStringWithoutThousandFormatWithDecimal = currencyStringWithoutThousandFormat.replace(
    decimalFormat,
    '.',
  );
  const amount = +currencyStringWithoutThousandFormatWithDecimal;
  if (isNaN(amount)) {
    return {};
  }

  return {
    currency: matchedCurrency,
    amount,
  };
};

export default parseFare;
